


































































































































































import Vue from 'vue';
import Item from '@/classes/item/item';
import Const from '@/classes/const';
import CommonCalc from '@/classes/commonCalc';
import ItemMaster from '@/classes/item/itemMaster';

export default Vue.extend({
  name: 'ItemTooltip',
  props: {
    value: {
      type: Item,
      required: true,
    },
  },
  data: () => ({
    avoidTexts: Const.AVOID_TYPE.map((v) => v.text),
    rangeText: ['', 'Short', 'Medium', 'Long', 'Very Long', 'Very Long+', 'Super Long', 'Super Long+', 'Global', 'Global+'],
  }),
  computed: {
    formatStatus() {
      return (value: number) => (value ? `${Math.floor(100 * value) / 100}` : '');
    },
    growSpeedString() {
      return (itemMaster: ItemMaster) => CommonCalc.getGrowSpeedString(itemMaster);
    },
  },
});
